import routesAdmin from "./routes.admin.js";
// import routesClient from "./routes.client";
// import VistaDocumento from "./routes.VistaDocumento";
// import { Error404 } from "../pages";
// import { BasicLayout } from "../layouts";

const routes = [ 
    ...routesAdmin, 
    // ...routesClient, 
    // ...VistaDocumento,
    // {path:"*",layout: BasicLayout,component: Error404,},
]

export default routes;